import layoutSlice, { actions, selectors } from "./reducer";
import * as thunkActions from "./actions";
export const layoutActions = { ...actions, ...thunkActions };
export const layoutSelectors = selectors;
export * as LayoutTypes from './types';
export default layoutSlice;